import React from 'react';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import { useLocalStore } from '../local-store-provider/LocalStoreProvider.utils';
import { RevenueCalculatorStore } from '../revenue-calculator/RevenueCalculator.store';
import { observer } from 'mobx-react';
import { toCurrency } from '../../utils/currency/currency.utils';
import { CurrencyCode } from '../../utils/currency/currency.constants';
import { displayStringNumber } from '../../utils/utils';
import { COLORS_COOLGRAY30, COLORS_LIGHTGRAYBG } from '../../App.constants';
import { CustomTableCell } from './custom-table-cell/CustomTableCell';

export const CalculatorTotalsMobile: React.FC = observer(() => {
  const localStore = useLocalStore<RevenueCalculatorStore>();

  return (
    <Box paddingX={3}>
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: COLORS_COOLGRAY30 }}>
            <CustomTableCell></CustomTableCell>
            <CustomTableCell
              isCenter={true}
              align="right"
              sx={{ fontWeight: 600, lineHeight: '1.2rem' }}
            >
              Billable Employees
            </CustomTableCell>
            <CustomTableCell
              sx={{ fontWeight: 600, lineHeight: '1.2rem' }}
              align="right"
            >
              Non-Billable Employees
            </CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <CustomTableCell>Billable Utilization</CustomTableCell>
            <CustomTableCell
              isCenter={true}
              align="right"
            >
              {localStore.billableEmployeeUtilizationTarget}%
            </CustomTableCell>
            <CustomTableCell align="right">0%</CustomTableCell>
          </TableRow>
          <TableRow sx={{ borderTop: 'none', borderBottom: 'none', backgroundColor: COLORS_LIGHTGRAYBG }}>
            <CustomTableCell>Head Count</CustomTableCell>
            <CustomTableCell
              isCenter={true}
              align="right"
            >
              {localStore.billableEmployeeCount}
            </CustomTableCell>
            <CustomTableCell align="right">{localStore.nonBillEmployeeCount}</CustomTableCell>
          </TableRow>
          <TableRow>
            <CustomTableCell>Available Hours</CustomTableCell>
            <CustomTableCell
              isCenter={true}
              align="right"
            >
              {displayStringNumber(localStore.availableBillableHours)}h
            </CustomTableCell>
            <CustomTableCell align="right">{displayStringNumber(localStore.availableNonBillHours)}h</CustomTableCell>
          </TableRow>
          <TableRow sx={{ borderTop: 'none', borderBottom: 'none', backgroundColor: COLORS_LIGHTGRAYBG }}>
            <CustomTableCell>Billable Hours</CustomTableCell>
            <CustomTableCell
              isCenter={true}
              align="right"
            >
              {displayStringNumber(localStore.billableHours)}h
            </CustomTableCell>
            <CustomTableCell align="right">0h</CustomTableCell>
          </TableRow>
          <TableRow>
            <CustomTableCell>Avg. Hourly Bill Rate</CustomTableCell>
            <CustomTableCell
              isCenter={true}
              align="right"
            >
              {toCurrency(localStore.averageHourlyBillRate, { currencyCode: CurrencyCode.USD, fractionDigits: 2 })}
            </CustomTableCell>
            <CustomTableCell align="right">$0.00</CustomTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
});

CalculatorTotalsMobile.displayName = 'CalculatorTotalsMobile';
